import { AvailableType, FindResearchOrderColumn, MeasurePurposeEnum, OrderType, SearchResearchSelectType, SearchSelectType, TermsLangEnum, TermsOrderColumnEnum, TermsTypeEnum, UserRestrictType, UserSexType } from "@/enum";
import { localStorageGetItems } from "@/lib/localStorage.api";
import { AdminSignUpType, UserLoginType } from "@/types/users.types";
import { isTokenExpired } from "@/util/token";

const axios = require('axios');

export class BackendApi {
  backendUrl = process.env.NEXT_PUBLIC_BACKEND_SERVER;

  async existEmailCheck(email: string) {
    try {
      // 해당 이메일을 요청
      const res = await axios.post(`${this.backendUrl}/advertiser-api/53/check/email`, {
        email
      })
        .then((response: any) => {
          return response['data']
        })
        .catch((err: any) => {
          console.log('BackendApi existEmailCheck Error : ', err);
          throw new Error(err)
        })
        .finally(console.log('BackendApi existEmailCheck finish'))

      // 중복여부 확인
      return res;
    } catch (err) {
      return err;
    }
  }

  // 관리자 로그인
  async loginEmailUser(email: string, password: string): Promise<UserLoginType> {
    try {
      console.log("backendUrl : ", this.backendUrl);
      const res = await axios.post(`${this.backendUrl}/admin-api/46/login`, {
        email, password
      })
        .then((response: any) => {
          console.log("BackendApi loginEmailUser data : ", response['data']);
          return response['data']
        })
        .catch((err: any) => {
          console.log("BackendApi loginEmailUser Error : ", err['response']['data']);
          const message: string = err['response']['data']['message'];
          alert(`${message}`);
          return err['response']['data'];
        })
        .finally(() => console.log('BackendApi loginEmailUser finish'))

      return res;


    } catch (err) {
      console.log("BackendApi loginEmailUser error : ", err);
      return {
        data: '',
        success: false,
        timestamp: new Date(),
      }
    }

  }

  async signUpEmailUser(dto: AdminSignUpType) {
    try {
      console.log("backendUrl : ", this.backendUrl);
      const res = await axios.post(`${this.backendUrl}/advertiser-api/20/signup/email`, {
        ...dto
      })
        .then((response: any) => {
          return response['data']
        })
        .catch((err: any) => {
          throw new Error(err)
        })
        .finally(console.log('BackendApi signUpEmailUser finish'))

      return res;


    } catch (err) {
      console.log("BackendApi signUpEmailUser error : ", err);
      return err;

    }
  }

  // #52 API 여러 유저의 상태를 조회한다.
  async findManyUsers(dto:
    {
      token: string,
      searchSelect: SearchSelectType,
      userRestrict: UserRestrictType,
      skip: number,
      take: number,
      keyword: string,
      order: OrderType,
      orderColumn: string,
    }) {

    let { token, searchSelect, userRestrict, skip, take, keyword, order, orderColumn } = dto;

    if (keyword.length <= 0) keyword = '-';

    const res = await axios.get(`${this.backendUrl}/user-admin-api/52/find/many/${searchSelect}/${userRestrict}/${keyword}/${skip}/${take}/${order}/${orderColumn}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then((response: any) => {
        console.log("BackendApi findManyUsers then response['data'] : ", response['data']);
        return response['data']
      })
      .catch((err: any) => {
        console.log('BackendApi findManyUsers Error : ', err);
        return err['response']['data']
      })
      .finally(() => console.log('BackendApi findManyMusic finish'))

    return res;

  }

  // #55 관리자가 유저의 ID를 이용해서 유저 정보를 불러온다.
  async findOneByUserId(
    token: string,
    id: number
  ) {
    const res = await axios.get(`${this.backendUrl}/user-admin-api/55/find/one/id/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then((response: any) => {
        console.log("BackendApi findOneByUserId then response['data'] : ", response['data']);
        return response['data']
      })
      .catch((err: any) => {
        console.log('BackendApi findOneByUserId Error : ', err);
        return err['response']['data']
      })
      .finally(() => console.log('BackendApi findOneByUserId finish'))

    return res;
  }

  // #32 API refresh 토큰을 이용해서 access, refresh 토큰 둘다 업데이트
  async updateManyUserData(
    dtos: {
      id: number,
      restrict: UserRestrictType
    }[]
  ): Promise<any> {

    console.log("BackendApi updateManyUserData Start");

    const token: string = this.getToken();

    console.log("BackendApi updateManyUserData dtos : ", dtos)

    const res = await axios.patch(`${this.backendUrl}/user-admin-api/58/update/many`,
      { data: dtos },
      {
        headers: {
          Authorization: `Bearer ${token}`
        },
      })
      .then((response: any) => {
        console.log("BackendApi findOneByUserId then response['data'] : ", response['data']);
        return response['data']
      })
      .catch((err: any) => {
        console.log('BackendApi findOneByUserId Error : ', err);
        return err['response']['data']
      })
      .finally(() => console.log('BackendApi findOneByUserId finish'))

    return res;
  }

  // #8 API 약관을 생성
  async createOneTerm(
    dto: {
      orderId: number,
      type: TermsTypeEnum
      title: string,
      body: string,
      language: TermsLangEnum,
      available: boolean,
      essential: boolean
    }
  ): Promise<any> {

    console.log("BackendApi createOneTerm Start");

    const token: string = this.getToken();

    console.log("BackendApi createOneTerm dto : ", dto);

    const res = await axios.post(`${this.backendUrl}/terms-admin-api/8/create/one`,
      dto,
      {
        headers: {
          Authorization: `Bearer ${token}`
        },
      })
      .then((response: any) => {
        console.log("BackendApi createOneTerm then response['data'] : ", response['data']);
        return response['data']
      })
      .catch((err: any) => {
        console.log('BackendApi createOneTerm Error : ', err);
        return err['response']['data']
      })
      .finally(() => console.log('BackendApi createOneTerm finish'))

    return res;
  }

  // #9 API 약관을 수정
  async updateOneTerm(
    id: number,
    dto: {
      orderId?: number,
      type?: TermsTypeEnum
      title?: string,
      body?: string,
      language?: TermsLangEnum,
      available?: boolean,
      essential?: boolean
    }
  ): Promise<any> {

    console.log("BackendApi updateOneTerm Start");

    const token: string = this.getToken();

    console.log("BackendApi updateOneTerm dto : ", dto);

    const res = await axios.patch(`${this.backendUrl}/terms-admin-api/9/update/${id}`,
      dto,
      {
        headers: {
          Authorization: `Bearer ${token}`
        },
      })
      .then((response: any) => {
        console.log("BackendApi updateOneTerm then response['data'] : ", response['data']);
        return response['data']
      })
      .catch((err: any) => {
        console.log('BackendApi updateOneTerm Error : ', err);
        return err['response']['data']
      })
      .finally(() => console.log('BackendApi updateOneTerm finish'))

    return res;
  }

  // #11 약관을 삭제
  async deleteOneTerm(
    id: number
  ): Promise<any> {

    console.log("BackendApi deleteOneTerm Start");

    const token: string = this.getToken();

    console.log("BackendApi deleteOneTerm id : ", id);

    const res = await axios.delete(`${this.backendUrl}/terms-admin-api/11/delete/one/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        },
      })
      .then((response: any) => {
        console.log("BackendApi deleteOneTerm then response['data'] : ", response['data']);
        return response['data']
      })
      .catch((err: any) => {
        console.log('BackendApi deleteOneTerm Error : ', err);
        return err['response']['data']
      })
      .finally(() => console.log('BackendApi deleteOneTerm finish'))

    return res;
  }

  // #29 관리자가 약관을 조건에 따라 조회한다.
  async findAllTermsByOptions(
    dto: {
      lang: TermsLangEnum,
      type: TermsTypeEnum,
      order: OrderType,
      orderColumn: TermsOrderColumnEnum,
      availableType: AvailableType,
      essentialType: AvailableType
    } = {
        lang: TermsLangEnum.korean,
        type: TermsTypeEnum.user,
        order: OrderType.DESC,
        orderColumn: TermsOrderColumnEnum.id,
        availableType: AvailableType.ALL,
        essentialType: AvailableType.ALL
      }
  ): Promise<any> {

    console.log("BackendApi findManyTerms Start");

    const token: string = this.getToken();

    console.log("BackendApi findManyTerms dto : ", dto)

    const { lang, type, order, orderColumn, availableType, essentialType } = dto;

    const res = await axios.get(`${this.backendUrl}/terms-admin-api/29/find/all/${lang}/${type}/${order}/${orderColumn}/${availableType}/${essentialType}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        },
      })
      .then((response: any) => {
        console.log("BackendApi findOneByUserId then response['data'] : ", response['data']);
        return response['data']
      })
      .catch((err: any) => {
        console.log('BackendApi findManyTerms Error : ', err);
        return err['response']['data']
      })
      .finally(() => console.log('BackendApi findManyTerms finish'))

    return res;
  }

  // #71 연구용계정(시리얼번호)을 생성한다.
  async createOneResearchAccount(
    dto: {
      sex: UserSexType,
      name: string,
      birthday?: Date,
      mobile?: string,
      memo?: string,
      measure_purpose: MeasurePurposeEnum
    } = {
        sex: UserSexType.MALE,
        name: '알렉스',
        birthday: new Date(),
        mobile: '01012345678',
        memo: undefined,
        measure_purpose: MeasurePurposeEnum.건강관리
      }
  ): Promise<any> {

    console.log("BackendApi createOneResearchAccount Start");

    const token: string = this.getToken();

    console.log("BackendApi createOneResearchAccount dto : ", dto);

    const res = await axios.post(`${this.backendUrl}/test-user-admin-api/71/create/one`,
      dto,
      {
        headers: {
          Authorization: `Bearer ${token}`
        },
      })
      .then((response: any) => {
        console.log("BackendApi createOneResearchAccount then response['data'] : ", response['data']);
        return response['data']
      })
      .catch((err: any) => {
        console.log('BackendApi createOneResearchAccount Error : ', err);
        return err['response']['data']
      })
      .finally(() => console.log('BackendApi createOneResearchAccount finish'))

    return res;
  }

  // #74 연구용 계정 여러개를 조회한다.
  async findManyResearchAccounts(
    dto:
      {
        searchSelect: SearchResearchSelectType,
        approvalStatus: AvailableType,
        skip: number,
        take: number,
        keyword: string,
        order: OrderType,
        orderColumn: FindResearchOrderColumn,
      } = {
        searchSelect: SearchResearchSelectType.all,
        approvalStatus: AvailableType.ALL,
        skip: 0,
        take: 10,
        keyword: '-',
        order: OrderType.DESC,
        orderColumn: FindResearchOrderColumn.id
      }
  ) {
    console.log("BackendApi findManyResearchAccounts Start");

    const token: string = this.getToken();

    let { searchSelect, approvalStatus, skip, take, keyword, order, orderColumn } = dto;

    if (keyword.length <= 0) keyword = '-';

    const res = await axios.get(`${this.backendUrl}/test-user-admin-api/74/find/many/${searchSelect}/${approvalStatus}/${keyword}/${skip}/${take}/${order}/${orderColumn}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    })
      .then((response: any) => {
        console.log("BackendApi findManyUsers then response['data'] : ", response['data']);
        return response['data']
      })
      .catch((err: any) => {
        console.log('BackendApi findManyUsers Error : ', err);
        return err['response']['data']
      })
      .finally(() => console.log('BackendApi findManyMusic finish'))

    return res;



  }

  getToken(): string {
    const token: string = localStorageGetItems(['token'])['token'];

    if (!token) throw new Error('토큰이 비어있음');
    else if (isTokenExpired(token)) {
      alert("재 로그인이 필요합니다.")
      window.location.href = '/login';
      throw new Error('토큰이 만료되었습니다.')
    }

    return token;
  }

}
